module.exports = __webpack_public_path__ + "img/amx-4.919586ce.jpg";